import { FiInfo } from "react-icons/fi";

export function Attachments({ attachments, isCancelled }) {
  if (!attachments?.length) return null;

  // Filter out shipment-related attachments if order is cancelled
  const filtered = isCancelled
    ? attachments.filter((a) => a.label === "Payment Invoice")
    : attachments;

  if (!filtered.length) return null;

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 mt-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Attachments</h3>
      {isCancelled && <CancelledNotice />}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((attachment, i) => (
          <AttachmentCard
            key={i}
            icon={attachment.icon}
            filename={attachment.filename}
            link={attachment.link}
            label={attachment.label}
          />
        ))}
      </div>
    </div>
  );
}

function AttachmentCard({ icon, filename, link, label }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="
        group
        flex flex-col sm:flex-row items-start sm:items-center gap-4
        p-4 rounded-xl
        bg-gradient-to-br from-white to-white/90
        border border-gray-200
        cursor-pointer
        transition-all duration-200
        hover:from-[#E0F2FF] hover:to-[#D0E8FF]
        hover:scale-[1.02]
      "
    >
      {/* Icon */}
      <div
        className="
          w-12 h-12 flex items-center justify-center
          rounded-lg
          bg-blue-100 text-blue-600
          transition-all duration-200
          group-hover:bg-blue-200 group-hover:text-blue-700
          flex-shrink-0
          text-2xl
        "
      >
        {icon}
      </div>

      {/* Text */}
      <div className="flex-1 min-w-0 flex flex-col gap-1">
        <p className="text-sm font-semibold text-gray-900 truncate">{label}</p>
        <p className="text-xs text-gray-500 truncate">{filename}</p>
      </div>

      {/* Arrow */}
      <div className="text-gray-400 transition-transform duration-200 group-hover:translate-x-1 flex-shrink-0 mt-1 sm:mt-0">
        <svg
          className="w-5 h-5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M14 5l7 7m0 0l-7 7m7-7H3"
          />
        </svg>
      </div>
    </a>
  );
}

function CancelledNotice() {
  return (
    <div className="flex items-start gap-2 p-3 mb-4 bg-gray-100 rounded-lg border border-gray-200">
      {/* Info Icon */}
      <FiInfo className="w-5 h-5 text-gray-500 flex-shrink-0 mt-0.5" />

      {/* Text */}
      <p className="text-sm text-gray-700">
        Some shipment documents are hidden because this order was cancelled.
      </p>
    </div>
  );
}
